import { usePresentationContext } from '@mentimeter/question-modules-contexts';
import { useQuizMetaContext } from '@mentimeter/quiz';
import { ViewOnlyPresentationDataHandler } from './ViewOnlyPresentationDataHandler';
import { LivePresentationDataHandler } from './LivePresentationDataHandler';

export function QuizLeaderboardPresentationDataHandler() {
  const { useQuestion, useConfig } = usePresentationContext();
  const { leaderboardHasTimeBasedScoringBasedOnPreviousQuiz } =
    useQuizMetaContext();
  const { mode } = useConfig();
  const { time_based_scoring } = useQuestion();
  const timeBasedScoring =
    leaderboardHasTimeBasedScoringBasedOnPreviousQuiz ?? time_based_scoring;

  if (mode !== 'live') {
    return (
      <ViewOnlyPresentationDataHandler timeBasedScoring={timeBasedScoring} />
    );
  }

  return <LivePresentationDataHandler timeBasedScoring={timeBasedScoring} />;
}
